export enum SampleStatusEnum {
  RECEIVED = 'received',
  FINISHED = 'finished'
}
